// import api models
import { MinCostPerSquareFootWithId } from '@app/models/api';

interface MinCostPerSquareFootVersionState {
    areMinCostsPerSquareFootLoaded: boolean;
    minCostsPerSquareFoot: MinCostPerSquareFootWithId[];
    selectedMinCostPerSquareFootId?: number | undefined;
};

const getInitialState = (): MinCostPerSquareFootVersionState => {
    return {
        areMinCostsPerSquareFootLoaded: false,
        minCostsPerSquareFoot: [],
        selectedMinCostPerSquareFootId: undefined
    };
};

export { getInitialState, MinCostPerSquareFootVersionState };